import { Link } from "react-router-dom";
import Wordmark from "../Wordmark";

const NAV = [
  { to: "/", label: "Start" },
  { to: "/produkter", label: "Produkter" },
  { to: "/sa-fungerar-det", label: "Så fungerar det" },
  { to: "/om-vido", label: "Om Vido" },
  { to: "/kontakt", label: "Kontakt" },
];

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-[color:hsl(var(--line))] bg-[hsl(var(--surface))]"
  >
    <div className="container-vido py-12 md:py-14 grid gap-10 md:grid-cols-3">
      <div>
        <Wordmark size="lg" />
        <p className="mt-4 text-sm text-[color:hsl(var(--muted-ink))] max-w-[22ch]">
          Klimatteknik utan onödigt krångel.
        </p>
      </div>

      <div>
        <h4 className="text-sm font-semibold text-[color:hsl(var(--ink))] mb-4 font-sans">
          Navigera
        </h4>
        <ul className="space-y-2">
          {NAV.map((n) => (
            <li key={n.to}>
              <Link
                to={n.to}
                data-testid={`footer-nav-${n.to === "/" ? "start" : n.to.slice(1)}`}
                className="text-sm text-[color:hsl(var(--muted-ink))] hover:text-[color:hsl(var(--ink))] transition-colors"
              >
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-sm font-semibold text-[color:hsl(var(--ink))] mb-4 font-sans">
          Kontakt
        </h4>
        <ul className="space-y-2 text-sm text-[color:hsl(var(--muted-ink))]">
          <li className="text-[color:hsl(var(--ink))]">Vido Klimatteknik</li>
          <li>
            <a
              href="tel:0793228187"
              data-testid="footer-phone"
              className="hover:text-[color:hsl(var(--ink))] transition-colors"
            >
              079-322 81 87
            </a>
          </li>
          <li>
            <a
              href="mailto:mikael@vido.nu"
              data-testid="footer-email"
              className="hover:text-[color:hsl(var(--ink))] transition-colors"
            >
              mikael@vido.nu
            </a>
          </li>
          <li className="pt-2">Lidköping · Götene · Skara</li>
        </ul>
      </div>
    </div>

    <div className="border-t border-[color:hsl(var(--line))]">
      <div className="container-vido py-5 text-xs text-[color:hsl(var(--muted-ink))] flex flex-col md:flex-row md:justify-between gap-2">
        <span data-testid="footer-copyright">
          © 2026 Vido Klimatteknik AB.
        </span>
        <span>Fasta priser. Installerat och klart.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
